import e from "./ghl-ui.es1399.js";
import f from "./ghl-ui.es1400.js";
import i from "./ghl-ui.es1401.js";
function d(o, t, r) {
  return t === t ? i(o, t, r) : e(o, f, r);
}
export {
  d as default
};
